export default "__VITE_ASSET__CUmGJ8rY__"